import { AthleteDTO } from "./AthletesDTO";
import { TimingPositionsDTO } from "./TimingPositionsDTO";

export interface LevelsDTO {
        Level: number;
        ID: number;
        RaceID: number;
        ClassID: number;
        Name: string;
        StartTime: Date | null;
        ActiveIpos: number;
        IsSprintFinal: boolean;
        SortOrder: number;
        Athletes: { [key: number]: AthleteDTO };
        TimePos: { [key: number]: TimingPositionsDTO };
        Status: LevelStatusEnum;
        Count: Counting;
    }

    export interface Counting {
        InFinish: number;
        InCourse: number;
        OnStart: number;
        HaveStatus: { [key: string]: number };

        new(): Counting;
    }

    export enum LevelStatusEnum {
        ReadyForStart = 1,
        Running = 2,
        Active = 3,
        Canceled = 11,
        ResultConfirmed = 101
    }